export const DeletedIcon = ({ onClick, color, fill = "#D0E2F5" }) => {
    return (
      <svg
        onClick={onClick}
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="30" height="30" rx="15" fill={fill} />
        <path
          d="M21 10.9863H9"
          stroke="#67809A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.668 10.314L12.8146 9.44065C12.9213 8.80732 13.0013 8.33398 14.128 8.33398H15.8746C17.0013 8.33398 17.088 8.83398 17.188 9.44732L17.3346 10.314"
          stroke="#67809A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.5669 11.0938L19.1336 19.8071C19.0603 20.8537 19.0003 21.6671 17.1403 21.6671H12.8603C11.0003 21.6671 10.9403 20.8537 10.8669 19.8071L10.4336 11.0938"
          stroke="#67809A"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  };
  